import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { CountryService } from '../../main-layout/country/country.service';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';


@Component({
  selector: 'app-countrymodal',
  templateUrl: './countrymodal.component.html',
  styleUrls: ['./countrymodal.component.css']
})
export class CountrymodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  saveTitle = 'Add';
  countryform: FormGroup;
  isEdit: boolean = false;
  existingdetails: any = {};
  onlyView: any;
  activeFlag = [
    { labelname: 'Active', value: 'Y' },
    { labelname: 'Inactive', value: 'N' }
  ];
  message: GlobalMessage = new GlobalMessage()
  constructor(
    private countryService: CountryService,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title === 'Modify Country') {
      this.isEdit = true;
      this.saveTitle = 'Modify';
      this.existingdetails = dataFromParent.datas;
    }
  }

  ngOnInit() {
    this.formInitialize();
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0]);
    }
  }

  public validation_message = {
    countryname: [
      { type: 'required', message: 'Country name is required.' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters not allowed ( % and \' ).' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    activeflag: [{ type: 'required', message: 'Active flag is required.' }],
  };

  patchValueForms(data) {
    this.countryform.patchValue({
      countryname: data?.countryname,
      activeflag: data?.activeflag
    });
  }


  formInitialize() {
    this.countryform = this.fb.group({
      countryname: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])],
      activeflag: ['Y'] // Ensure this field is included if needed
    });
  }

  add() {
    if (this.countryform.invalid) {
      this.validateAllFormFields(this.countryform);
      return;
    }
    else {
      if (this.saveTitle === 'Modify') {
        this.modify(this.countryform.value);
      } else {
        if (this.countryform.invalid) {
          this.validateAllFormFields(this.countryform);
        }
        else {
          Swal.fire({
            title: "Do you want to save the changes?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Save",
            denyButtonText: "Don't save"
          }).then((value) => {
            if (value.isConfirmed) {
              let data = this.countryform.value;
              data['csrftoken'] = this.CSRFToken
              this.countryService.addCountry(data).subscribe({
                next: (response: any) => {                 
                  if (response.response === 'exists') {
                    Swal.fire("Country already exists!", "", "error").then(() => {
                    });
                  } else {
                    Swal.fire("Country added successfully!", "", "success").then(() => {
                      this.ref.close();
                    });
                  }
                },
                error: (error) => {
                  Swal.fire({
                    title: "Error Saving Country",
                    text: error.error.message || "An unexpected error occurred.",
                    icon: "error",
                  });
                },
              });
            }

            else if (value.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        }
      }
    }
  }

  modify(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: "Don't save"
    }).then((value) => {
      if (value.isConfirmed) {
        let data = this.countryform.value;
        data['csrftoken'] = this.CSRFToken;
        data.countryid = this.existingdetails[0].countryid; // Ensure correct assignment

        this.countryService.updateCountry(data).subscribe({
          next: (response: any) => {
            console.log('Modify response:', response);
 
            if (response?.response === 'exists') {
              Swal.fire("Country already exists!", "", "error");
            } else {
              Swal.fire("Country modified successfully!", "", "success").then(() => {
                this.ref.close();
              });
            }
          },
          error: (error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.error?.error || "An unexpected error occurred.",
              footer: `Error status is: ${error.status}`
            });
          }
        });
      } else if (value.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  }


  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}
